// test929
(929 && 0);
